

































import PSelect from '../p-select/p-select.vue';
import colorable from '../../mixins/colorable/colorable';
import interactable from '../../mixins/interactable/interactable';
import mixins from '../../mixins';

export default mixins(colorable, interactable).extend({
  mixins: [colorable, interactable],
  props: {
    ...((new PSelect()).$options.props),
  },
  data: () => ({
    internalItems: [],
  }),
  watch: {
    items() {
      this.internalItems = this.items;
    },
  },
  methods: {
    onFocus() {
      (this as any).internalItems = [];
    },
  },
});
